import React, {useState} from 'react';
import {observer} from 'mobx-react-lite';
import {useService} from '@yosmanyga/di';
import {Button, Container, I18NText, Icon, useIcons} from '@yosmanyga/rich-ui';
import {RestorationPromptController} from '../../controller';

const RestorationAction = observer(
    ({onRestore}: { onRestore: () => void }) => {
        const [confirmation, setConfirmation] = useState(false);

        const icons = useIcons();

        const restorationPromptController = useService(
            RestorationPromptController,
            []
        );

        return <Container
            flow="column"
            align={{
                cross: 'center',
            }}
            margin={{
                top: 4,
            }}
            width='100%'
        >
            {!confirmation ? <>
                <I18NText>Select the actions to undo</I18NText>
                <Button
                    intent='secondary'
                    onClick={() => {
                        setConfirmation(true);
                    }}
                    disabled={
                        typeof restorationPromptController.selected === 'undefined'
                    }
                    margin={{
                        top: 1,
                    }}
                >
                    <Icon
                        component={icons.actions.undo}
                        size='xxs'
                    />
                    <I18NText>Undo</I18NText>
                </Button>
            </> : <>
                <I18NText>Undo actions?</I18NText>
                <Container
                    flow="row"
                    align={{
                        main: 'center',
                        cross: 'center',
                    }}
                    margin={{
                        top: 1,
                    }}
                    width='100%'
                >
                    <Button
                        intent='secondary'
                        onClick={() => {
                            setConfirmation(false);
                        }}
                    >
                        <Icon
                            component={icons.actions.back}
                            size='xxs'
                        />
                        <I18NText>No, cancel</I18NText>
                    </Button>
                    <Button
                        intent='negative'
                        margin={{
                            left: 1,
                        }}
                        progress={restorationPromptController.restoring}
                        onClick={async () => {
                            await restorationPromptController.restore();

                            onRestore();
                        }}
                    >
                        <Icon
                            component={icons.actions.undo}
                            size='xxs'
                        />
                        <I18NText>Yes, undo</I18NText>
                    </Button>
                </Container>
            </>}
        </Container>
    }
);

export {RestorationAction};
